import { BASE_URL } from '../endpoints'
import { get, getApiParams } from '../https'

//get all signups
export const getAllSignupCount = (schoolData: string[]): Promise<unknown> => {
  const schoolsQuery = schoolData
    ?.map((school) => `schools[]=${encodeURIComponent(school)}`)
    .join('&')
  return get(`${BASE_URL}/home/sign-ups?${schoolsQuery}`)
}

//get whistleblowing and incidents
export const getWhistleAndIncidentsCount = (
  schools: string[]
): Promise<unknown> => {
  // Construct params object with 'schools' key containing the array of strings
  const params = { schools: schools }

  return getApiParams(`${BASE_URL}/home/whistle-blowing-and-incidents`, params)
}

//policies

export const getAllPoliciesCount = (schools: string[]): Promise<unknown> => {
  // Construct params object with 'schools' key containing the array of strings
  const params = { schools: schools }

  return getApiParams(`${BASE_URL}/home/policies`, params)
}

//count stats

export const getAllStatsCount = (schools: string[]): Promise<unknown> => {
  // Construct params object with 'schools' key containing the array of strings
  const params = { schools: schools }

  return getApiParams(`${BASE_URL}/home/count-stats`, params)
}

//profile-complition

export const getProfileStats = (schools: string[]): Promise<unknown> => {
  // Construct params object with 'schools' key containing the array of strings
  const params = { schools: schools }

  return getApiParams(`${BASE_URL}/home/profile-completion-breakdown`, params)
}
